<pr-content-container height="h-full" padding="p-0" overflow="overflow-hidden">
  <mat-progress-bar *ngIf="store.loading$ | async" mode="indeterminate" />
  <table
    mat-table
    matSort
    matSortActive="createdAt"
    matSortDirection="desc"
    [dataSource]="table"
    [trackBy]="trackByRef"
  >
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr
      *matRowDef="let record; columns: displayedColumns"
      mat-row
      class="cursor-pointer hover:bg-gray-100"
      [ngClass]="{
        '!bg-primary-50 !font-bold':
          [currentStaffer(), record] | map: hasUnreadChanges
      }"
      (click)="referralSelected.emit(record)"
    ></tr>
    <!-- Patient Column -->
    <ng-container matColumnDef="patient">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Patient
      </th>
      <td *matCellDef="let record" mat-cell>
        @if (record.patient; as patient) {
          {{ record.patient.name }}
        }
      </td>
    </ng-container>
    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Type
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        <pr-referral-type-chip [type]="record.type" />
      </td>
    </ng-container>
    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Status
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        <pr-referral-status [status]="record.status" />
      </td>
    </ng-container>
    <!-- Created On Column  -->
    <ng-container matColumnDef="createdAt">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Created On
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        {{ record.createdAt | moment | amDateFormat: dateFormat }}
      </td>
    </ng-container>
    <!-- Urgency Column -->
    <ng-container matColumnDef="urgency">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Urgency
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.urgency) {
          {{ record.urgency | titlecase }}
        }
      </td>
    </ng-container>
    <!-- From Column -->
    <ng-container matColumnDef="referrer">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        From
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.referrer) {
          {{ record.referrer.name }}
        }
      </td>
    </ng-container>
    <!-- To Column -->
    <ng-container matColumnDef="recipient">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        To
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.recipient) {
          {{ record.recipient.name }}
        }
      </td>
    </ng-container>
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell class="flex-row-reverse truncate">
        Actions
      </th>
      <td *matCellDef="let record" mat-cell class="flex-row-reverse truncate">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()"
        >
          @if ([currentStaffer(), record] | map: hasUnreadChanges) {
            <span
              class="absolute right-0 top-1 h-2 w-2 rounded-full bg-[#f44336]"
            ></span>
          }
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <pr-referral-menu-status-buttons
            [referral]="record"
            (updateStatus)="
              referralUpdated.emit({
                referral: record,
                changes: { status: $event }
              })
            "
          />

          <mat-divider />

          <button
            mat-menu-item
            (click)="handleMenuAction($event, 'edit', record)"
          >
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
          @if (record.patient) {
            <a
              mat-menu-item
              target="_blank"
              [routerLink]="record.patient | patientUrl$ | async"
            >
              <mat-icon>open_in_new</mat-icon>
              Open Patient
            </a>
          }
          <button
            mat-menu-item
            class="!text-warn-500"
            (click)="handleMenuAction($event, 'delete', record)"
          >
            <mat-icon class="!text-warn-500">delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
  </table>

  @if (emptySearch()) {
    <pr-empty-state
      class="layout-margin"
      image="search"
      title="search results"
      [searchInputValue]="store.searchTerm$ | async"
    />
  }

  <mat-paginator
    #paginator
    class="sticky bottom-0 z-50"
    showFirstLastButtons
    [length]="totalRecordCount()"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  />
</pr-content-container>
